/* eslint-disable react-hooks/exhaustive-deps */
import { Layout, Modal, Tabs } from 'antd';
import queryString from 'query-string';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import OfflineAndRtmpCameraComponent from './AddCamera/OfflineCamera';
import RTSPlinkAddCameraComponent from './AddCamera/RTSPlinkAddCamera';
import AddDeviceCamera from './AddDeviceCamera';
import StorageVideoComponent from './StorageVideo';
import UpdateCameraComponent from './UpdateCamera';
import UpdateStreamComponent from './UpdateStream';
import './index.scss';
import { CameraTree } from '../../components/Tree/Camera';
import { RECENT_GROUP_ID } from '../../constants/group';
import { ListCamera } from '../../components/Tree/Camera/ListCamera';
import { ApartmentOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { CUSTOM_GROUP_ID } from '../../components/Tree/Camera/constant';
import { CAMERA_TYPE } from '../../constants';
import MilestonePlaybackComponent from '../../components/Playback/MilestonePlayback';
import { beeXLogger } from '../../helpers/logger';
import {
  resetRecoveryCameraPage,
  updateRecoveryCameraPage,
} from '../../redux/recovery/action';
import { getRecoveryCameraPage } from '../../redux/recovery/reducer';

const { Sider } = Layout;
const { TabPane } = Tabs;

const makeRecentItemKey = (userId, namespace) => {
  return `recent-camera-items-${userId}-${namespace}`;
};

const getLocalRecentItems = (userId, namespace) => {
  try {
    return JSON.parse(
      localStorage.getItem(makeRecentItemKey(userId, namespace)) || '[]',
    );
  } catch (error) {
    return [];
  }
};

const setLocalRecentItems = (userId, namespace, items) => {
  beeXLogger.debug('local-items', items);
  localStorage.setItem(
    makeRecentItemKey(userId, namespace),
    JSON.stringify(items),
  );
};

const CameraPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const {
    userId,
    isAuth,
    cameras: pageCameras,
    updateDevice,
    namespace,
    addDeviceData,
    checkExternalDevice,
    activeDeviceData,
  } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [cameras, setCameras] = useState();
  const [total, setTotal] = useState(0);
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [selectCamera, setSelectCamera] = useState();
  const [customCamera, setCustomCamera] = useState();
  const [visibleEdit, setVisibleEdit] = useState();
  const [visibleStream, setVisibleStream] = useState();

  const [visibleAddCamera, setVisibleAddCamera] = useState(false);
  const [addDeviceReturn, setAddDeviceReturn] = useState(addDeviceData);
  const [checkExternalDeviceReturn, setCheckExternalDeviceReturn] = useState();
  const [activeDeviceReturn, setActiveDeviceReturn] =
    useState(activeDeviceData);
  const [dataSearchCamera, setDataSearchCamera] = useState();
  const [key, setKey] = useState(Math.random());
  const [nameCameraSearch, setNameCameraSearch] = useState();
  const [keyTab, setKeyTab] = useState('1');

  const {
    sidebarMode,
    selectedGroup: recoverySelectedGroup,
    selectedCamera: recoverySelectedCamera,
    visibleModalAddCamera: recoveryVisibleModalAddCamera,
    activeAddCameraTab: recoveryActiveAddCameraTab,
    cameraToEdit: recoveryCameraToEdit,
    cameraToUpdateStream: recoveryCameraToUpdateStream,
  } = useSelector(getRecoveryCameraPage);

  useEffect(() => {
    return () => {
      setAddDeviceReturn(null);
      setCheckExternalDeviceReturn(null);
      setActiveDeviceReturn(null);
    };
  }, []);

  useEffect(() => {
    if (pageCameras) {
      setCameras(pageCameras.data);
      setTotal(pageCameras.totalSize);
      if (pageCameras.data?.length === 1) {
        if (
          !pageCameras.data?.[0]?.permission ||
          !pageCameras.data?.[0]?.permission?.split('_')?.includes('playback')
        )
          return;
        dispatch(
          updateRecoveryCameraPage({ selectedCamera: pageCameras.data?.[0] }),
        );
        setSelectCamera(pageCameras.data?.[0]);
      }
    }
  }, [pageCameras]);

  useEffect(() => {
    const { redirect, camera } = queryString.parse(location.search);
    const { key } = queryString.parse(location.hash);
    if (
      redirect &&
      key &&
      cameras &&
      cameras.some((child) => child.serial === key)
    ) {
      history.push('#storage');
      setNameCameraSearch(camera);
      const cameraSelected = cameras
        ? cameras.filter((cam) => cam.serial === key)[0]
        : null;
      dispatch(
        updateRecoveryCameraPage({
          selectedCamera: cameraSelected,
        }),
      );
      return setSelectCamera(cameraSelected);
    }
  }, [cameras, history, location]);

  const [updateReturn, setUpdateReturn] = useState();
  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setUpdateReturn(updateDevice);
      if (page && isAuth === 1 && pageSize && namespace) {
        getDeviceByPage(page - 1, pageSize);
      }
    }
  }, [updateDevice]);
  useEffect(() => {
    if (
      visibleEdit &&
      updateReturn &&
      updateReturn.serial === visibleEdit.serial
    ) {
      if (updateReturn.isSuccess) {
        setCameras((state) =>
          state.map((camera) => {
            if (camera.serial !== updateReturn.data.serial) return camera;
            return { ...camera, ...updateReturn.data };
          }),
        );
        setUpdateReturn(null);
        setVisibleEdit(null);
      }
    }
  }, [updateReturn, visibleEdit]);

  useEffect(() => {
    setAddDeviceReturn(addDeviceData);
  }, [addDeviceData]);

  useEffect(() => {
    setCheckExternalDeviceReturn(checkExternalDevice);
  }, [checkExternalDevice]);

  useEffect(() => {
    setActiveDeviceReturn(activeDeviceData);
  }, [activeDeviceData]);

  const onUpdateDevice = useCallback(
    (data) => {
      if (data && visibleEdit) {
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify({ ...data, namespace }),
        };

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, visibleEdit],
  );

  const onUpdateCamera = useCallback(
    (data, requestId) => {
      if (data) {
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId,
          body: JSON.stringify({
            ...data,
            namespace,
          }),
        };

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const getDeviceByPage = useCallback(
    (page, size, dataSearch) => {
      let data = {
        namespace,
        deviceType: 'camera',
        timeRequest: requestId,
        page,
        size,
      };
      if (dataSearch) {
        data.name = dataSearch;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, requestId],
  );
  useEffect(() => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize, dataSearchCamera);
    }
  }, [getDeviceByPage, isAuth, namespace, page, pageSize]);

  const onDeviceByPage = () => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize);
    }
  };

  const onDeviceSelect = () => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize + 10);
    }
  };

  const onRequireActiveDevice = useCallback(
    (serial) => {
      if (serial && serial.length > 0) {
        let data = {
          serial: serial.trim(),
          namespace,
        };

        let dataObj = {
          appServiceType: SERVICE.REQUIRE_ACTIVE_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const onCheckExternalDevice = useCallback(
    (serial, cameraType = '') => {
      if (serial && serial.length > 0) {
        let data = {
          serial: serial.trim(),
          namespace,
          deviceType: 'camera',
          extraInfo: {},
        };
        if (cameraType) {
          data.extraInfo.factorySerial = cameraType;
        }
        let dataObj = {
          appServiceType: SERVICE.CHECK_EXTERNAL_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const onAddDevice = useCallback(
    (serial, activationCode) => {
      if (
        serial &&
        serial.length > 0 &&
        activationCode &&
        activationCode.length > 0
      ) {
        let data = {
          serial,
          activationCode,
          namespace,
        };

        let dataObj = {
          appServiceType: SERVICE.ADD_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const onAddCamera = useCallback(
    (serial, name, deviceSerial, typeCamera) => {
      if (serial && serial.length > 0 && name && name.length > 0) {
        let data = {
          namespace,
          serial: deviceSerial,
          deviceType: 'camera',
          extraInfo: {
            typeCamera: typeCamera, //'offline_camera',
            name: name.trim(),
            factorySerial: serial,
          },
        };

        let dataObj = {
          appServiceType: SERVICE.REQUEST_ADD_EXTERNAL_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const handleChangeTab = (value) => {
    setKeyTab(value);
    dispatch(updateRecoveryCameraPage({ activeAddCameraTab: value }));

    if (value === 'list') {
      setCustomCamera(null);
    }
  };

  useEffect(() => {
    if (recoveryActiveAddCameraTab && recoveryActiveAddCameraTab !== keyTab) {
      setKeyTab(recoveryActiveAddCameraTab);
    }
  }, [recoveryActiveAddCameraTab, keyTab]);

  const [recentItems, setRecentItems] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState({ id: RECENT_GROUP_ID });

  useEffect(() => {
    beeXLogger.debug('UPDATE RETURN', updateReturn);
    if (updateReturn && updateReturn.isSuccess) {
      setRecentItems((prev) => {
        return prev.map((item) => {
          if (
            item.type === 'camera' &&
            item.data.serial === updateReturn.data.serial
          ) {
            return { ...item, data: updateReturn.data };
          }

          return item;
        });
      });
    }
  }, [updateReturn, setRecentItems]);

  useEffect(() => {
    setRecentItems(getLocalRecentItems(userId, namespace));
  }, [userId, namespace]);

  useEffect(() => {
    beeXLogger.debug('recentItems', recentItems);
    beeXLogger.debug('local-items', getLocalRecentItems(userId, namespace));
    if (!userId || !namespace) {
      return;
    }

    setLocalRecentItems(userId, namespace, recentItems);
  }, [recentItems, userId, namespace]);

  const [activeTab, setActiveTab] = useState('list');

  const addCameraToRecent = (camera) => {
    setRecentItems((prev) => {
      const newItems = prev.filter(
        (item) => item.type !== 'camera' || item.data.serial !== camera.serial,
      );

      return [{ data: camera, type: 'camera' }, ...newItems];
    });
    // openMessage(NOTIFIES.INFO, 'Camera added to recent');
  };

  const removeCameraFromRecent = (serial) => {
    setRecentItems((prev) => {
      return prev.filter(
        (item) => item.type !== 'camera' || item.data.serial !== serial,
      );
    });
  };

  const getIsCameraPinned = (serial) => {
    return recentItems.some(
      (item) => item.type === 'camera' && item.data.serial === serial,
    );
  };

  const onPinCamera = (cam, pinned) => {
    if (pinned) {
      addCameraToRecent(cam);

      return;
    }

    Modal.confirm({
      title: 'Unpin camera',
      content: 'Are you sure you want to unpin this camera?',
      onOk: () => {
        removeCameraFromRecent(cam.serial);
      },
    });
  };

  const camerasForList = useMemo(() => {
    if (customCamera) {
      beeXLogger.debug('🚀 ~ CameraPage ~ customCamera:', customCamera);
      return [customCamera];
    }

    if (selectedGroup?.id === RECENT_GROUP_ID) {
      return recentItems
        .filter((item) => item.type === 'camera')
        .map((item) => item.data);
    }

    return undefined;
  }, [cameras, getIsCameraPinned, selectedGroup?.id, customCamera]);

  const setAsCustomCamera = (camera) => {
    setCustomCamera(camera);

    if (camera) {
      setSelectCamera(camera);
      dispatch(updateRecoveryCameraPage({ selectedCamera: camera }));
    }
  };

  const cameraTreeRef = useRef();

  const onSelectGroup = (group) => {
    setSelectedGroup(group);
    dispatch(
      updateRecoveryCameraPage({
        selectedGroup: group,
        pagination: { page: 1, size: 15 },
      }),
    );
  };

  useEffect(() => {
    if (
      recoverySelectedGroup &&
      recoverySelectedGroup.id !== selectedGroup?.id
    ) {
      setSelectedGroup(recoverySelectedGroup);
    }
  }, [recoverySelectedGroup, selectedGroup]);

  const onTabChange = (key) => {
    setActiveTab(key);
    dispatch(
      updateRecoveryCameraPage({
        sidebarMode: key,
      }),
    );
  };

  useEffect(() => {
    if (sidebarMode && sidebarMode !== activeTab) {
      setActiveTab(sidebarMode);
    }
  }, [sidebarMode, activeTab]);

  const onSelectCamera = (camera) => {
    setSelectCamera(camera);
    dispatch(updateRecoveryCameraPage({ selectedCamera: camera }));
  };

  useEffect(() => {
    if (
      recoverySelectedCamera &&
      recoverySelectedCamera.serial !== selectCamera?.serial
    ) {
      setSelectCamera(recoverySelectedCamera);
    }
  }, [recoverySelectedCamera, selectCamera]);

  useEffect(() => {
    if (recoveryVisibleModalAddCamera !== visibleAddCamera) {
      setVisibleAddCamera(recoveryVisibleModalAddCamera);
    }
  }, [recoveryVisibleModalAddCamera, visibleAddCamera]);

  useEffect(() => {
    return () => {
      dispatch(resetRecoveryCameraPage());
    };
  }, []);

  const handleCloseModalAddCamera = () => {
    dispatch(
      updateRecoveryCameraPage({
        visibleModalAddCamera: false,
        rtspAddMethod: null,
        activeAddCameraTab: '1',
      }),
    );
  };

  const handleSelectCameraToEdit = (camera) => {
    setVisibleEdit(camera);
    dispatch(updateRecoveryCameraPage({ cameraToEdit: camera }));
  };

  useEffect(() => {
    if (
      recoveryCameraToEdit &&
      recoveryCameraToEdit?.serial !== visibleEdit?.serial
    ) {
      setVisibleEdit(recoveryCameraToEdit);
    }
  }, [recoveryCameraToEdit, visibleEdit]);

  useEffect(() => {
    if (
      recoveryCameraToUpdateStream &&
      recoveryCameraToUpdateStream?.serial !== visibleStream?.serial
    ) {
      setVisibleStream(recoveryCameraToUpdateStream);
    }
  }, [recoveryCameraToUpdateStream, visibleStream]);

  return (
    <div className="camera-management-component">
      <Modal
        visible={visibleAddCamera}
        onCancel={() => {
          setVisibleAddCamera(false);
          setKey(Math.random());
          handleCloseModalAddCamera();
        }}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {visibleAddCamera && (
          <div className="add-camera-component">
            <Tabs
              key={key}
              defaultActiveKey={keyTab || '1'}
              onChange={handleChangeTab}
            >
              <TabPane tab={t('Camera 3/4G')} key="1">
                {keyTab === '1' && (
                  <AddDeviceCamera
                    dispatch={dispatch}
                    addDeviceReturn={addDeviceReturn}
                    activeDeviceReturn={activeDeviceReturn}
                    onRequireActiveDevice={onRequireActiveDevice}
                    onAddDevice={onAddDevice}
                    onUpdate={onUpdateCamera}
                    namespace={namespace}
                    handleAddSuccessful={() => {
                      setVisibleAddCamera(false);
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                  />
                )}
              </TabPane>
              <TabPane tab={t('RTSP Link')} key="2">
                {keyTab === '2' && (
                  <RTSPlinkAddCameraComponent
                    onDone={() => {
                      setVisibleAddCamera(false);
                      handleCloseModalAddCamera();
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                    gatewaySerial=""
                  />
                )}
              </TabPane>
              <TabPane tab={t('Offline Camera')} key="3">
                {keyTab === '3' && (
                  <OfflineAndRtmpCameraComponent
                    typeCamera="offline_camera"
                    dispatch={dispatch}
                    checkDeviceReturn={checkExternalDeviceReturn}
                    activeDeviceReturn={activeDeviceReturn}
                    onCheckExternalDevice={onCheckExternalDevice}
                    onAddCamera={onAddCamera}
                    onUpdate={onUpdateCamera}
                    handleAddSuccessful={() => {
                      setVisibleAddCamera(false);
                      handleCloseModalAddCamera();
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                  />
                )}
              </TabPane>
              <TabPane tab={t('RTMP Camera')} key="4">
                {keyTab === '4' && (
                  <OfflineAndRtmpCameraComponent
                    typeCamera="rtmp_camera"
                    dispatch={dispatch}
                    checkDeviceReturn={checkExternalDeviceReturn}
                    activeDeviceReturn={activeDeviceReturn}
                    onCheckExternalDevice={onCheckExternalDevice}
                    onAddCamera={onAddCamera}
                    onUpdate={onUpdateCamera}
                    handleAddSuccessful={() => {
                      setVisibleAddCamera(false);
                      handleCloseModalAddCamera();
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                  />
                )}
              </TabPane>
            </Tabs>
          </div>
        )}
      </Modal>
      <Modal
        title={t('Update camera')}
        visible={!!visibleEdit}
        onCancel={() => {
          setVisibleEdit(null);
          dispatch(updateRecoveryCameraPage({ cameraToEdit: null }));
        }}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {!!visibleEdit && (
          <UpdateCameraComponent
            updateDataReturn={updateReturn}
            onCancel={() => {
              setVisibleEdit(null);
              dispatch(updateRecoveryCameraPage({ cameraToEdit: null }));
            }}
            onUpdate={onUpdateDevice}
            data={visibleEdit}
          />
        )}
      </Modal>
      <Modal
        title={t('Update stream')}
        visible={!!visibleStream}
        onCancel={() => {
          setVisibleStream(null);
          dispatch(updateRecoveryCameraPage({ cameraToUpdateStream: null }));
        }}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <UpdateStreamComponent
          onCancel={() => {
            setVisibleStream(null);
            dispatch(updateRecoveryCameraPage({ cameraToUpdateStream: null }));
          }}
          onUpdate={onUpdateDevice}
          data={visibleStream}
        />
      </Modal>
      <Layout>
        <Sider width={324} style={{ paddingLeft: '16px', paddingTop: '12px' }}>
          {/* <ListCameraComponent
            handleUpdateCamera={(camera) => setVisibleEdit(camera)}
            handleUpdateStream={(camera) => setVisibleStream(camera)}
            getDeviceByPage={getDeviceByPage}
            data={cameras}
            page={page}
            setPage={setPage}
            total={total}
            pageSize={pageSize}
            setPageSize={setPageSize}
            selectCamera={selectCamera}
            setSelect={setSelectCamera}
            onDeviceByPage={onDeviceByPage}
            setDataSearchCamera={setDataSearchCamera}
            nameCameraSearch={nameCameraSearch}
          /> */}

          <Tabs activeKey={activeTab} onChange={onTabChange}>
            <Tabs.TabPane
              tab={
                <span>
                  <UnorderedListOutlined /> List
                </span>
              }
              key="list"
            >
              <ListCamera
                getIsCameraPinned={getIsCameraPinned}
                onPinCamera={onPinCamera}
                onSelectCamera={onSelectCamera}
                selectedGroup={selectedGroup}
                selectedSerial={selectCamera?.serial}
                onSelectGroup={onSelectGroup}
                namespace={namespace}
                cameras={camerasForList}
                onUpdateCamera={handleSelectCameraToEdit}
                onUpdateStream={(camera) => {
                  setVisibleStream(camera);
                  dispatch(
                    updateRecoveryCameraPage({
                      cameraToUpdateStream: camera,
                    }),
                  );
                }}
                updateReturn={updateReturn}
                onCameraRemoved={(groupId, serial) => {
                  if (
                    cameraTreeRef.current &&
                    cameraTreeRef.current.markDirty
                  ) {
                    cameraTreeRef.current.markDirty(groupId);
                  }
                }}
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              tab={
                <span>
                  <ApartmentOutlined /> Tree
                </span>
              }
              key="tree"
            >
              <CameraTree
                namespace={namespace}
                recentItems={recentItems}
                setRecentItems={setRecentItems}
                onSelect={onSelectGroup}
                selectedId={selectedGroup?.id}
                onSelectCamera={onSelectCamera}
                onUpdateCamera={handleSelectCameraToEdit}
                onUpdateStream={(camera) => {
                  setVisibleStream(camera);
                  dispatch(
                    updateRecoveryCameraPage({
                      cameraToUpdateStream: camera,
                    }),
                  );
                }}
                updateReturn={updateReturn}
                selectedSerial={selectCamera?.serial}
                setAsCustomCamera={setAsCustomCamera}
                ref={cameraTreeRef}
                onPinCamera={onPinCamera}
                getIsCameraPinned={getIsCameraPinned}
                customCamera={customCamera}
              />
            </Tabs.TabPane>
          </Tabs>
        </Sider>
        <Layout style={{ padding: '0 8px' }}>
          {selectCamera?.typeCamera === CAMERA_TYPE.MILESTONE ? (
            <MilestonePlaybackComponent
              serial={selectCamera && selectCamera.serial}
              permission={selectCamera && selectCamera.permission}
              handleAddCamera={() => {
                setVisibleAddCamera(true);
                dispatch(
                  updateRecoveryCameraPage({
                    visibleModalAddCamera: true,
                  }),
                );
              }}
              selectCamera={selectCamera}
            />
          ) : (
            <StorageVideoComponent
              serial={selectCamera && selectCamera.serial}
              permission={selectCamera && selectCamera.permission}
              handleAddCamera={() => {
                setVisibleAddCamera(true);
                dispatch(
                  updateRecoveryCameraPage({
                    visibleModalAddCamera: true,
                  }),
                );
              }}
              selectCamera={selectCamera}
            />
          )}
        </Layout>
      </Layout>
    </div>
  );
};

export default CameraPage;
